import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "LiveOnlineStatistics" }
const _hoisted_2 = { style: {"height":"60px","display":"inline-flex","margin":"0 auto"} }
const _hoisted_3 = { style: {"height":"60px","line-height":"60px","text-align":"center","margin-left":"14px"} }

import { searchFormConfig } from '@/views/main/live/liveOnlineStatistics/config/search.config'
import { contentTableConfig } from '@/views/main/live/liveOnlineStatistics/config/content.config'
import { usePageSearch } from '@/hooks/userPageSearch'
import { getPageListData } from '@/service/main/system'
import { secondToString } from '@/utils/date-format'
import { useRoute } from 'vue-router'

import { useStore } from '@/store'
import dayjs from 'dayjs'
import localCache from '@/utils/cache'
import { initEmptyParam } from '@/hooks/useInitParam'


export default /*#__PURE__*/_defineComponent({
  __name: 'LiveOnlineStatistics',
  setup(__props) {

initEmptyParam()
let eventData
const getEventList = async () => {
  eventData = await getPageListData('/main/customerEvents/queryByCondition', {
    pageNo: 1,
    pageSize: 1000
  })
  const channels = searchFormConfig.formItems.find(
    (item) => item.field === 'channelId'
  )
  channels!.options = eventData.list.map((item: any) => {
    return { title: item.eventName, value: item.rowId.toString() }
  })
}
getEventList()

const store = useStore()
const userInfo = store.state.login.userInfo
const route = useRoute()

const getEmp = async () => {
  let userList = localCache.getCache('empData')
  const userOptions = userList.map((item: any) => {
    return { title: item.realName, value: item.id }
  })
  const userItem = searchFormConfig.formItems.find(
    (item) => item.field === 'empIds'
  )
  userItem!.options = userOptions
}
getEmp()

const getDept = () => {
  const dept = searchFormConfig.formItems.find(
    (item) => item.field === 'deptId'
  )
  const deptData = store.state.login.depts
  dept!.options = deptData.map((item: any) => {
    return { title: item.name, value: item.id }
  })
}
getDept()

const queryParam = {
  accessTime: [
    dayjs().startOf('date').format('YYYY-MM-DD HH:mm:ss'),
    dayjs().endOf('date').format('YYYY-MM-DD HH:mm:ss')
  ],
  ...route.query
}
store.commit('system/changeQueyryInfo', queryParam)

const handleSortChange = (value: any) => {
  console.log(value)
  store.commit('system/changeOrderInfo', {
    orderBy: value.prop,
    orderType: value.order
  })
  const queryInfo = store.state.system.queryInfo
  pageContentRef.value?.getPageData(queryInfo)
}

const resetCb = () => {
  return queryParam
}

const [
  pageContentRef,
  handleResetClick,
  handleSearchClick,
  handleDownBtnClick,
  handleSummaryBtnClick
] = usePageSearch(resetCb)

return (_ctx: any,_cache: any) => {
  const _component_PageSearch = _resolveComponent("PageSearch")!
  const _component_el_link = _resolveComponent("el-link")!
  const _component_el_avatar = _resolveComponent("el-avatar")!
  const _component_PageContent = _resolveComponent("PageContent")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_PageSearch, {
      searchFormConfig: _unref(searchFormConfig),
      onResetBtnClick: _unref(handleResetClick),
      onSearchBtnClick: _unref(handleSearchClick)
    }, null, 8, ["searchFormConfig", "onResetBtnClick", "onSearchBtnClick"]),
    _createVNode(_component_PageContent, {
      ref_key: "pageContentRef",
      ref: pageContentRef,
      contentTableConfig: _unref(contentTableConfig),
      pageName: "liveOnlineStatistics",
      downFilename: "直播间在线客户统计.xlsx",
      summaryFilename: "直播间在线观看人数汇总.xlsx",
      onDownBtnClick: _unref(handleDownBtnClick),
      onSummaryBtnClick: _unref(handleSummaryBtnClick),
      onSortChange: handleSortChange
    }, {
      duration: _withCtx((scope) => [
        _createElementVNode("div", null, _toDisplayString(_unref(secondToString)(scope.row.newDuration)), 1)
      ]),
      material: _withCtx((scope) => [
        _createVNode(_component_el_link, {
          href: scope.row.url,
          type: "primary",
          target: "_blank"
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(scope.row.title), 1)
          ]),
          _: 2
        }, 1032, ["href"])
      ]),
      consumer: _withCtx((scope) => [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_el_avatar, {
            shape: "square",
            size: 60,
            src: scope.row.consumerHeadImgUrl
          }, null, 8, ["src"]),
          _createElementVNode("span", _hoisted_3, _toDisplayString(scope.row.consumerNickName), 1)
        ])
      ]),
      _: 1
    }, 8, ["contentTableConfig", "onDownBtnClick", "onSummaryBtnClick"])
  ]))
}
}

})